export interface TranslationEntry {
  message: string;
  description: string;
}

const faCollaboratorsSection: Record<string, TranslationEntry> = {
  "page.settings.collaboratorsDescription": {
    message:
      "مدیریت کنید چه کسانی می‌توانند به این دفتر دسترسی داشته و در آن همکاری کنند",
    description: "Description for collaborators settings section",
  },
};

export default faCollaboratorsSection;
